<template>
<div class="">
<user-top></user-top>
<div class="ht tc mt50">个人资料</div>
<div class="layui-form millia" lay-filter="BasicInfo">
<!--基本信息-->
<form  action="">
<ul class="UserList">
<li>
<input type="text" name="realname" placeholder="请输入真实姓名" class="layui-input" lay-verify="required">
</li>
<li>
<img :src="BasicImg" class="upLoadImg">
<span class="upLoadImgBt">点击上传图片(限制10M以内)
<input type="file" name="img" accept="image/gif,image/jpeg,image/jpg,image/png" @change="changeImage($event)">
</span>
</li>
<li>
<select name="sex" id="sex" lay-filter="sex" lay-verify="required">
<option value="">请选择性别</option>
<option value="1">男</option>
<option value="2">女</option>
</select>
</li>
<li>
<input type="text" name="birthday" class="layui-input timeFlie" placeholder="请选择出生日期" id="birthday" lay-verify="required">
</li>
<li>
<input type="text" name="id_card" placeholder="请输入身份证号" class="layui-input" lay-verify="required|identity">
</li>
<li>
<input type="text" name="household" placeholder="请输入籍贯所在地" class="layui-input" lay-verify="required">
</li>
<!--<li>
<select name="nation" lay-filter="nation" lay-verify="required">
<option value="">请选择民族</option>
<option v-for="nations in BasicInfo.nation" :value="nations.id" :key="nations.id">
{{nations.name}}
</option>
</select>
</li>-->
<li>
<select name="political_status" lay-filter="political_status" lay-verify="required">
<option value="">请选政治面貌</option>
<option v-for="political_statuss in BasicInfo.political_status" :value="political_statuss.id" :key="political_statuss.id">
{{political_statuss.name}}
</option>
</select>
</li>
<li>
<input type="text" name="graduated_school" placeholder="请输入毕业院校" class="layui-input" lay-verify="required">
</li>
<li>
<input type="text" name="major" placeholder="请输入所学专业" lay-verify="required" class="layui-input">
</li>
<li>
<select name="education" lay-filter="education" lay-verify="required">
<option value="">请选择学历</option>
<option v-for="educations in BasicInfo.education" :value="educations.id" :key="educations.id">
{{educations.name}}
</option>
</select>
</li>
<li>
<select name="degree" lay-filter="degree">
<option value="">请选择学位</option>
<option v-for="degrees in BasicInfo.degree" :value="degrees.id" :key="degrees.id">
{{degrees.name}}
</option>
</select>
</li>
<li>
<input type="text" name="graduated_time" class="layui-input timeFlie" placeholder="毕业时间" id="graduate" lay-verify="required">
</li>
<li>
<input type="text" name="work_time" class="layui-input timeFlie" placeholder="参加工作时间" lay-verify="required" id="startWork">
</li>
<!--<li>
<input type="text" name="employer" placeholder="请输入现在工作单位" class="layui-input">
</li>-->
<!--<li>
<select name="user_type" lay-filter="user_type" lay-verify="required">
<option value="">请选择状态</option>
<option v-for="types in BasicInfo.type" :value="types.id" :key="types.id">
{{types.name}}
</option>
</select>
</li>-->
<!--<li>
<textarea name="other" placeholder="其他补充说明" class="layui-textarea"></textarea>
</li>-->
<li><button lay-submit type="button" class="layui-btn layui-btn-fluid layui-btn-normal" lay-filter="BasicInfoEndter">确认基本信息</button>
</li>
</ul>
</form>
</div>
</div>
</template>
<script>
import UserTop from '@/components/UserTop.vue'
export default {
    name: "BasicInfo",
    inject: ["reload"],
    components:{
        UserTop
    },
    data () {
        return {
            BasicInfo:{
                nation:{},//民族数据
                political_status:{},//政治面貌数据
                education:{},//学历数据
                degree:{},//学位数据
                type:{},//身份状态数据
            },
            BasicData:{},//用户所有信息要存入的对象
            cacheImg:"",//头像提交本地地址
            OnLineImg:"",//图片线上相对地址
            BasicImg:"",//图片加载完成地址
            allData: {},//获取用户保存后的所有信息
            img_url:{},//图片线上绝对地址
        }
    },
    mounted () {
        this.GetNation();
        this.GetPolitical_status();
        this.GetEducation();
        this.GetDegree();
        this.GetType();
        //this.getAllData();

        //layui表单及弹出层相关
        var that = this;
        layui.use('form', function(){
            var $ = layui.$;
            var form = layui.form;
            //基本信息表单提交
            form.on('submit(BasicInfoEndter)', function(data){
                var BasicDatas = JSON.parse(JSON.stringify(data.field));
                //console.log(BasicDatas);
                that.BasicData = BasicDatas;
                that.BasicInfoEndter();
            });
        });

        //时间选择
        layui.use('laydate', function(){
            var laydate = layui.laydate;
            //出生日期
            laydate.render({
                elem:'#birthday',
                type:'date',
                trigger: 'click',
                min: '1987-7-20',
                //max: '2022-1-1'
            });
            //毕业时间
            laydate.render({
                elem:'#graduate',
                type:'month',
                trigger:'click',
            });
            //参加工作时间
            laydate.render({
                elem:'#startWork',
                type:'month',
                trigger:'click',
            });
        });

    },
    methods: {
        //获取民族
        GetNation(){
            let url = "api/login/getNationData";
            let params = {}
            this.$ajax.post(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.BasicInfo.nation = response.data.data;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },

        //获取政治面貌
        GetPolitical_status(){
            let url = "api/login/getPoliticalStatusData";
            let params = {}
            this.$ajax.post(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.BasicInfo.political_status = response.data.data;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },

        //获取学历
        GetEducation(){
            let url = "api/login/getEducationData";
            let params = {}
            this.$ajax.post(url, params).then(function (response) {
                if (response.data.status==1) {
                    this.BasicInfo.education = response.data.data;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },

        //获取学位
        GetDegree(){
            let url = "api/login/getDegreeData";
            let params = {}
            this.$ajax.post(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.BasicInfo.degree = response.data.data;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },

        //获取身份状态
        GetType(){
            let url = "api/login/getTypeData";
            let params = {}
            this.$ajax.post(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.BasicInfo.type = response.data.data;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },

        //头像提交
        uploadImg(event){
            let params = new FormData();
            params.append("img", this.cacheImg);
            let url = "api/user/saveUserImg";
            this.$ajax.post(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.OnLineImg = response.data.data.img;
                }else{
                    layer.alert(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
        //头像提交完毕后回显
        changeImage(event) {
            var files = event.target.files;
            var filename = files[0].name;
            var reader = new FileReader();
            reader.addEventListener('load',() => {
                this.BasicImg = reader.result
            });
            reader.readAsDataURL(files[0])
            this.cacheImg = files[0]
            this.uploadImg();
        },

        //基本信息提交
        BasicInfoEndter(){
            var params = {
                realname:this.BasicData.realname,
                img: this.OnLineImg,
                birthday:this.BasicData.birthday,
                sex:this.BasicData.sex,
                id_card:this.BasicData.id_card,
                nation:this.BasicData.nation,
                political_status:this.BasicData.political_status,
                user_type:this.BasicData.user_type,
                education:this.BasicData.education,
                degree:this.BasicData.degree,
                major:this.BasicData.major,
                graduated_school:this.BasicData.graduated_school,
                graduated_time:this.BasicData.graduated_time,
                work_time:this.BasicData.work_time,
                employer:this.BasicData.employer,
                household:this.BasicData.household,
                other:this.BasicData.other,
            }
            //console.log(params);
            let url = "api/user/saveUserInfo";
            this.$ajax.post(url,params).then(function (response) {
                if (response.data.status==1) {
                    //alert("基本信息提交成功");
                    layer.alert("基本信息提交成功");
                    this.$router.push("/UserInfo");
                }else{
                    layer.alert(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },

        //获取用户所有信息
        getAllData() {
            let url = "api/user/getUserInfo";
            let params = {}
            this.$ajax.get(url, params).then(function (response) {
                if (response.data.status==1) {
                    this.allData = response.data.data;
                    this.img_url = response.data.data.img_url;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
    },
    beforeMount() {
        this.getAllData();
	},
    watch: {
        allData(newAllData,oldAllData){
            if (JSON.stringify(this.allData) === '{}') {
                console.log("没有获取到用户已填信息");
            }else{
                console.log("获取到用户已填信息");
                //console.log(this.allData);
                this.BasicImg = this.img_url;
                var that = this;
                layui.use('form', function(){
                    var form = layui.form;
                    //表单的回显
                    form.val("BasicInfo", {
                        "realname":that.allData.realname,
                        "sex": that.allData.sex,
                        "birthday":that.allData.birthday,
                        "id_card":that.allData.id_card,
                        "nation":that.allData.nation,
                        "political_status":that.allData.political_status,
                        "user_type":that.allData.user_type,
                        "education":that.allData.education,
                        "degree":that.allData.degree,
                        "major":that.allData.major,
                        "graduated_school":that.allData.graduated_school,
                        "graduated_time":that.allData.graduated_time,
                        "work_time":that.allData.work_time,
                        "employer":that.allData.employer,
                        "household":that.allData.household,
                        "other":that.allData.other,
                    });
                    form.render("select");
                });
            }
        }
    },
    updated() {
        //layui select渲染
        layui.use('form', function(){
            var form = layui.form;
            form.render();
        });
    },
}
</script>
<style scoped>
.upLoadImg{display:block;margin-bottom:1rem;max-width:45%;height:auto;background:url(../assets/upLoadImg.png) no-repeat center center;max-width:15rem;max-height:15rem;/* min-height:8rem;min-width:8rem;border:1px solid #d0d0d0; */}
.upLoadImgBt{position:relative;display:inline-block;background:#D0EEFF;border:.1rem solid #99D3F5;border-radius:.5rem;padding:0 1rem;overflow:hidden;color:#1E88C7;font-size:1.4rem;line-height:3.8rem;}
.upLoadImgBt input{position:absolute;font-size:100px;right:0;top:0;opacity:0;}
</style>